<script>
  export let isSideBarVisible = false;
  export let onChangeAlphabet;
</script>

<style>
  aside {
    position: fixed;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    color: var(--color-bright);
    background: #151719;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    user-select: none;
  }
  .visible {
    left: 0;
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
</style>

<aside class:visible={isSideBarVisible}>
  <img src="images/diagram-pronunciation.png" alt="Diagram pronunciation" />
  <div>
    <label>
      <input
        type="radio"
        name="alphabet"
        on:change={onChangeAlphabet}
        value="dvngr"
        checked />
      Devanagari
    </label>

    <label>
      <input
        type="radio"
        name="alphabet"
        on:change={onChangeAlphabet}
        value="iast" />
      IAST
    </label>
  </div>
</aside>
